import { BaseApi } from "./base.api";
import {
  TAccountLeadInactivity,
  TAccountLeadInactivityPayload,
} from "types/account-lead-inactivity.type";

export class AccountLeadInactivityApi extends BaseApi {
  async fetchLeadInactivity(
    accountId: number
  ): Promise<TAccountLeadInactivity[]> {
    return this.get(`/accounts/${accountId}/lead-inactivity`);
  }

  async createLeadInactivity(
    accountId: number,
    leadInactivity: TAccountLeadInactivityPayload
  ): Promise<TAccountLeadInactivity> {
    return this.post(`/accounts/${accountId}/lead-inactivity`, leadInactivity);
  }

  async updateLeadInactivity(
    accountId: number,
    leadInactivityId: number,
    leadInactivity: TAccountLeadInactivityPayload
  ): Promise<TAccountLeadInactivity> {
    return this.put(
      `/accounts/${accountId}/lead-inactivity/${leadInactivityId}`,
      leadInactivity
    );
  }

  async deleteLeadInactivity(
    accountId: number,
    leadInactivityId: number
  ): Promise<void> {
    return this.del(
      `/accounts/${accountId}/lead-inactivity/${leadInactivityId}`
    );
  }
}
